var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-dialog',{attrs:{"title":_vm.title,"visible":_vm.isVisible,"close-on-click-modal":false,"append-to-body":_vm.isAppend,"fullscreen":_vm.fullscreen,"width":"100%"},on:{"update:visible":function($event){_vm.isVisible=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }